function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { WAIT_FOR_ACTION, ERROR_ACTION } from 'redux-wait-for-action';
import * as actionTypes from './actionTypes';
//----------------------------------------------------------------------------------------------------------------------
export const setOtp = (otpStatus, otpRegion, otpSignatureToken)=>({
        type: actionTypes.SET_OTP,
        payload: {
            otpStatus,
            otpRegion,
            otpSignatureToken
        }
    });
export const setVerifiedSignatureToken = (verifiedSignatureToken)=>({
        type: actionTypes.SET_VERIFIED_SIGNATURE_TOKEN,
        payload: {
            verifiedSignatureToken
        }
    });
export const clearOtp = ()=>({
        type: actionTypes.CLEAR_OTP
    });
export const setAvailableCountries = (countries = [])=>({
        type: actionTypes.SET_AVAILABLE_COUNTRIES,
        payload: {
            countries
        }
    });
export const setAvailableScopes = (scopes = [])=>({
        type: actionTypes.SET_AVAILABLE_SCOPES,
        payload: {
            scopes
        }
    });
export const setIdentities = (identities = [])=>({
        type: actionTypes.SET_IDENTITIES,
        payload: {
            identities
        }
    });
export const setResetPasswordIdentity = (identity = null)=>({
        type: actionTypes.SET_RESET_PASSWORD_IDENTITY,
        payload: {
            identity
        }
    });
export const setLoadedIdentity = (loadedIdentity = null)=>({
        type: actionTypes.SET_LOADED_IDENTITY,
        payload: {
            loadedIdentity
        }
    });
export const unsetInactiveIdentity = ()=>({
        type: actionTypes.UNSET_INACTIVE_IDENTITY
    });
export const chooseCountry = (country)=>({
        type: actionTypes.CHOOSE_COUNTRY,
        payload: {
            country
        }
    });
export const chooseScope = (scope)=>({
        type: actionTypes.CHOOSE_SCOPE,
        payload: {
            scope
        }
    });
export const setPassword = ({ password })=>({
        type: actionTypes.SET_PASSWORD,
        payload: {
            password
        }
    });
export const goToApp = (app)=>({
        type: actionTypes.GO_TO_APP,
        payload: {
            app
        }
    });
//----------------------------------------------------------------------------------------------------------------------
export const getMe = ()=>({
        type: actionTypes.GET_ME,
        [WAIT_FOR_ACTION]: actionTypes.GET_ME_SUCCESS,
        [ERROR_ACTION]: actionTypes.GET_ME_ERROR
    });
export const getMeSuccess = (account)=>({
        type: actionTypes.GET_ME_SUCCESS,
        payload: {
            account
        }
    });
export const getMeError = (error)=>({
        type: actionTypes.GET_ME_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const listWalletEntries = ({ holderUID, holderPassphrase })=>({
        type: actionTypes.LIST_WALLET_ENTRIES,
        payload: {
            holderUID,
            holderPassphrase
        }
    });
export const listWalletEntriesSuccess = (walletEntriesList)=>({
        type: actionTypes.LIST_WALLET_ENTRIES_SUCCESS,
        payload: {
            walletEntriesList
        }
    });
export const listWalletEntriesError = (error)=>({
        type: actionTypes.LIST_WALLET_ENTRIES_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const signUp = (values)=>({
        type: actionTypes.SIGN_UP,
        payload: _object_spread({}, values)
    });
export const signUpSuccess = (inactiveIdentity = null)=>({
        type: actionTypes.SIGN_UP_SUCCESS,
        payload: {
            inactiveIdentity
        }
    });
export const signUpError = (error)=>({
        type: actionTypes.SIGN_UP_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const initAuth = (prompt = null, returnPath = null)=>({
        type: actionTypes.INIT_AUTH,
        payload: {
            prompt,
            returnPath
        }
    });
//----------------------------------------------------------------------------------------------------------------------
export const signIn = ({ email, password, rememberMe, returnUrl })=>({
        type: actionTypes.SIGN_IN,
        payload: {
            email,
            password,
            rememberMe,
            returnUrl
        }
    });
export const signInCancel = ()=>({
        type: actionTypes.SIGN_IN_CANCEL
    });
export const signInSuccess = ()=>({
        type: actionTypes.SIGN_IN_SUCCESS
    });
export const signInError = (error, inactiveIdentity)=>({
        type: actionTypes.SIGN_IN_ERROR,
        payload: {
            inactiveIdentity
        },
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const resendOtp = ()=>({
        type: actionTypes.RESEND_OTP
    });
export const resendOtpSuccess = (otpSignatureToken)=>({
        type: actionTypes.RESEND_OTP_SUCCESS,
        payload: {
            otpSignatureToken
        }
    });
export const resendOtpError = (error)=>({
        type: actionTypes.RESEND_OTP_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const verifyOtp = (otp)=>({
        type: actionTypes.VERIFY_OTP,
        payload: {
            otp
        }
    });
export const verifyOtpSuccess = ()=>({
        type: actionTypes.VERIFY_OTP_SUCCESS
    });
export const verifyOtpError = (error, failedAttempts, lockoutEnd)=>({
        type: actionTypes.VERIFY_OTP_ERROR,
        payload: {
            failedAttempts,
            lockoutEnd
        },
        error
    });
//----------------------------------------------------------------------------------------------------------------------
// export const signInCallback = () => ({
//   type             : actionTypes.SIGN_IN_CALLBACK,
//   [WAIT_FOR_ACTION]: actionTypes.SIGN_IN_CALLBACK_SUCCESS,
//   [ERROR_ACTION]   : actionTypes.SIGN_IN_CALLBACK_ERROR,
// });
//
// export const signInCallbackSuccess = () => ({
//   type: actionTypes.SIGN_IN_CALLBACK_SUCCESS,
// });
//
// export const signInCallbackError = (error) => ({
//   type: actionTypes.SIGN_IN_CALLBACK_ERROR,
//   error,
// });
//----------------------------------------------------------------------------------------------------------------------
export const signOut = ({ preserveStorage = null } = {})=>({
        type: actionTypes.SIGN_OUT,
        payload: {
            preserveStorage
        }
    });
export const signOutSuccess = ()=>({
        type: actionTypes.SIGN_OUT_SUCCESS
    });
export const signOutError = (error)=>({
        type: actionTypes.SIGN_OUT_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const signOutCallback = (logoutId)=>({
        type: actionTypes.SIGN_OUT_CALLBACK,
        payload: {
            logoutId
        }
    });
export const signOutCallbackSuccess = ()=>({
        type: actionTypes.SIGN_OUT_CALLBACK_SUCCESS
    });
export const signOutCallbackError = (error)=>({
        type: actionTypes.SIGN_OUT_CALLBACK_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const fetchIdentityProviders = ()=>({
        type: actionTypes.FETCH_IDENTITY_PROVIDERS
    });
export const fetchIdentityProvidersSuccess = (identityProviders)=>({
        type: actionTypes.FETCH_IDENTITY_PROVIDERS_SUCCESS,
        payload: {
            identityProviders
        }
    });
export const fetchIdentityProvidersError = (error)=>({
        type: actionTypes.FETCH_IDENTITY_PROVIDERS_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const fetchIdentities = ()=>({
        type: actionTypes.FETCH_IDENTITIES
    });
export const fetchIdentitiesSuccess = (identities)=>({
        type: actionTypes.FETCH_IDENTITIES_SUCCESS,
        payload: {
            identities
        }
    });
export const fetchIdentitiesError = (error)=>({
        type: actionTypes.FETCH_IDENTITIES_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const switchIdentity = (identity, password = undefined)=>({
        type: actionTypes.SWITCH_IDENTITY,
        payload: {
            identity,
            password
        }
    });
export const switchIdentitySuccess = ()=>({
        type: actionTypes.SWITCH_IDENTITY_SUCCESS
    });
export const switchIdentityError = (error)=>({
        type: actionTypes.SWITCH_IDENTITY_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const confirmEmail = (token, returnUrl)=>({
        type: actionTypes.CONFIRM_EMAIL,
        payload: {
            token,
            returnUrl
        }
    });
export const confirmEmailSuccess = ()=>({
        type: actionTypes.CONFIRM_EMAIL_SUCCESS
    });
export const confirmEmailCancel = ()=>({
        type: actionTypes.CONFIRM_EMAIL_CANCEL
    });
export const confirmEmailError = (tokenExpired)=>({
        type: actionTypes.CONFIRM_EMAIL_ERROR,
        error: {
            tokenExpired
        }
    });
export const setConfirmEmailActivationType = (confirmEmailActivationType)=>({
        type: actionTypes.SET_CONFIRM_EMAIL_ACTIVATION_TYPE,
        payload: {
            confirmEmailActivationType
        }
    });
export const unsetConfirmEmailActivationType = ()=>({
        type: actionTypes.UNSET_CONFIRM_EMAIL_ACTIVATION_TYPE
    });
//----------------------------------------------------------------------------------------------------------------------
export const sendConfirmEmail = (email, password, identityProviderKey)=>({
        type: actionTypes.SEND_EMAIL_CONFIRM,
        payload: {
            email,
            password,
            identityProviderKey
        }
    });
export const sendConfirmEmailSuccess = ()=>({
        type: actionTypes.SEND_EMAIL_CONFIRM_SUCCESS
    });
export const sendConfirmEmailError = (error)=>({
        type: actionTypes.SEND_EMAIL_CONFIRM_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const checkConfirmTermsOfServicesByGuardian = (countryCode, token)=>({
        type: actionTypes.CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN,
        payload: {
            countryCode,
            token
        }
    });
export const checkConfirmTermsOfServicesByGuardianSuccess = ()=>({
        type: actionTypes.CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN_SUCCESS
    });
export const checkConfirmTermsOfServicesByGuardianError = (error)=>({
        type: actionTypes.CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const updateAccountSettings = ({ language })=>({
        type: actionTypes.UPDATE_ACCOUNT_SETTINGS,
        payload: {
            language
        }
    });
export const updateAccountSettingsSuccess = ({ language })=>({
        type: actionTypes.UPDATE_ACCOUNT_SETTINGS_SUCCESS,
        payload: {
            language
        }
    });
export const updateAccountSettingsError = (error)=>({
        type: actionTypes.UPDATE_ACCOUNT_SETTINGS_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const setInvitation = ()=>({
        type: actionTypes.SET_INVITATION,
        [WAIT_FOR_ACTION]: actionTypes.SET_INVITATION_SUCCESS,
        [ERROR_ACTION]: actionTypes.SET_INVITATION_ERROR
    });
export const setInvitationSuccess = (invitation = null, invitationToken = null)=>({
        type: actionTypes.SET_INVITATION_SUCCESS,
        payload: {
            invitation,
            invitationToken
        }
    });
export const setInvitationError = (error)=>({
        type: actionTypes.SET_INVITATION_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const acceptInvitation = (invitation, identityUID)=>({
        type: actionTypes.ACCEPT_INVITATION,
        payload: {
            invitation,
            identityUID
        }
    });
export const acceptInvitationWithNewProfile = (invitation, informationValues, password = undefined)=>({
        type: actionTypes.ACCEPT_INVITATION_WITH_NEW_PROFILE,
        payload: {
            invitation,
            informationValues,
            password
        }
    });
export const acceptInvitationSuccess = ()=>({
        type: actionTypes.ACCEPT_INVITATION_SUCCESS
    });
export const acceptInvitationError = (error)=>({
        type: actionTypes.ACCEPT_INVITATION_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const rejectInvitation = (invitation)=>({
        type: actionTypes.REJECT_INVITATION,
        payload: {
            invitation
        }
    });
export const rejectInvitationSuccess = ()=>({
        type: actionTypes.REJECT_INVITATION_SUCCESS
    });
export const rejectInvitationError = (error)=>({
        type: actionTypes.REJECT_INVITATION_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const fetchInvitationInformationTemplate = (invitation)=>({
        type: actionTypes.FETCH_INVITATION_INFORMATION_TEMPLATE,
        payload: {
            invitation
        }
    });
export const fetchInvitationInformationTemplateSuccess = (invitationInformationTemplate)=>({
        type: actionTypes.FETCH_INVITATION_INFORMATION_TEMPLATE_SUCCESS,
        payload: {
            invitationInformationTemplate
        }
    });
export const fetchInvitationInformationTemplateError = (error)=>({
        type: actionTypes.FETCH_INVITATION_INFORMATION_TEMPLATE_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const changePassword = ({ oldPassword, password })=>({
        type: actionTypes.CHANGE_PASSWORD,
        payload: {
            oldPassword,
            password
        }
    });
export const changePasswordSuccess = ()=>({
        type: actionTypes.CHANGE_PASSWORD_SUCCESS
    });
export const changePasswordError = (error)=>({
        type: actionTypes.CHANGE_PASSWORD_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const resetPassword = (email)=>({
        type: actionTypes.RESET_PASSWORD,
        payload: {
            email
        }
    });
export const setResetPasswordType = (resetPasswordType)=>({
        type: actionTypes.SET_RESET_PASSWORD_TYPE,
        payload: {
            resetPasswordType
        }
    });
export const resetPasswordCancel = ()=>({
        type: actionTypes.RESET_PASSWORD_CANCEL
    });
export const resetPasswordSuccess = ()=>({
        type: actionTypes.RESET_PASSWORD_SUCCESS
    });
export const resetPasswordError = (error)=>({
        type: actionTypes.RESET_PASSWORD_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const setNewPassword = (email)=>({
        type: actionTypes.SET_NEW_PASSWORD,
        payload: {
            email
        }
    });
export const setNewPasswordSuccess = ()=>({
        type: actionTypes.SET_NEW_PASSWORD_SUCCESS
    });
export const setNewPasswordError = (error)=>({
        type: actionTypes.SET_NEW_PASSWORD_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
// eslint-disable-next-line max-len
export const setNewPasswordCC = ({ identityProviderKey, email, temporaryPassword, password })=>({
        type: actionTypes.SET_NEW_PASSWORD_CC,
        payload: {
            identityProviderKey,
            email,
            temporaryPassword,
            password
        }
    });
export const setNewPasswordCCSuccess = (password)=>({
        type: actionTypes.SET_NEW_PASSWORD_CC_SUCCESS,
        payload: {
            password
        }
    });
export const setNewPasswordCCError = (error)=>({
        type: actionTypes.SET_NEW_PASSWORD_CC_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const setElevatedPermissionsMode = (mode)=>({
        type: actionTypes.SET_ELEVATED_PERMISSIONS_MODE,
        payload: mode
    });
//----------------------------------------------------------------------------------------------------------------------
export const elevatePermissions = ({ password })=>({
        type: actionTypes.ELEVATE_PERMISSIONS,
        payload: {
            password
        }
    });
export const elevatePermissionsSuccess = ()=>({
        type: actionTypes.ELEVATE_PERMISSIONS_SUCCESS
    });
export const elevatePermissionsError = (error)=>({
        type: actionTypes.ELEVATE_PERMISSIONS_ERROR,
        error
    });
export const elevatePermissionsTimeout = ()=>({
        type: actionTypes.ELEVATE_PERMISSIONS_TIMEOUT
    });
//----------------------------------------------------------------------------------------------------------------------
export const passphraseRecovery = ()=>({
        type: actionTypes.PASSPHRASE_RECOVERY
    });
export const passphraseRecoverySuccess = (passphrase)=>({
        type: actionTypes.PASSPHRASE_RECOVERY_SUCCESS,
        payload: {
            passphrase
        }
    });
export const passphraseRecoveryError = (error)=>({
        type: actionTypes.PASSPHRASE_RECOVERY_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const fetchOrganizationMemberships = ()=>({
        type: actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS
    });
export const fetchOrganizationMembershipsSuccess = (organizationMemberships)=>({
        type: actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_SUCCESS,
        payload: {
            organizationMemberships
        }
    });
export const fetchOrganizationMembershipsError = (error)=>({
        type: actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const approveOrganizationMembership = (organizationMembership)=>({
        type: actionTypes.APPROVE_ORGANIZATION_MEMBERSHIP,
        payload: {
            organizationMembership
        }
    });
export const approveOrganizationMembershipSuccess = (organizationMembership)=>({
        type: actionTypes.APPROVE_ORGANIZATION_MEMBERSHIP_SUCCESS,
        payload: {
            organizationMembership
        }
    });
export const approveOrganizationMembershipError = (error, organizationMembership)=>({
        type: actionTypes.APPROVE_ORGANIZATION_MEMBERSHIP_ERROR,
        payload: {
            organizationMembership
        },
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const rejectOrganizationMembership = (organizationMembership)=>({
        type: actionTypes.REJECT_ORGANIZATION_MEMBERSHIP,
        payload: {
            organizationMembership
        }
    });
export const rejectOrganizationMembershipSuccess = (organizationMembership)=>({
        type: actionTypes.REJECT_ORGANIZATION_MEMBERSHIP_SUCCESS,
        payload: {
            organizationMembership
        }
    });
export const rejectOrganizationMembershipError = (error, organizationMembership)=>({
        type: actionTypes.REJECT_ORGANIZATION_MEMBERSHIP_ERROR,
        payload: {
            organizationMembership
        },
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const test = (data)=>({
        type: actionTypes.TEST,
        payload: {
            data
        }
    });
//----------------------------------------------------------------------------------------------------------------------
export const deleteAccount = (password)=>({
        type: actionTypes.DELETE_ACCOUNT,
        payload: {
            password
        }
    });
export const deleteAccountSuccess = ()=>({
        type: actionTypes.DELETE_ACCOUNT_SUCCESS
    });
export const deleteAccountError = ()=>({
        type: actionTypes.DELETE_ACCOUNT_ERROR
    });
//----------------------------------------------------------------------------------------------------------------------
export const editGuardianEmail = (email)=>({
        type: actionTypes.EDIT_GUARDIAN_EMAIL,
        payload: {
            email
        }
    });
export const editGuardianEmailSuccess = ()=>({
        type: actionTypes.EDIT_GUARDIAN_EMAIL_SUCCESS
    });
export const editGuardianEmailError = ()=>({
        type: actionTypes.EDIT_GUARDIAN_EMAIL_ERROR
    });
//----------------------------------------------------------------------------------------------------------------------
export const clearErrors = ()=>({
        type: actionTypes.CLEAR_ERRORS
    });
